import React, { useEffect, useState } from 'react';
import bowser from 'yola-bowser';
import classNames from 'classnames';
import CreatableSelect from 'react-select/creatable';
import ClearButton from './components/clear-button';
import Control from './components/control';
import Input from './components/input';
import Tag from './components/tag';
import TagDeleteButton from './components/tag-delete-button';
import TagText from './components/tag-text';
import { defaultCreateOptionHandler } from './utils/default-create-option-handler';

const components = {
  ClearIndicator: ClearButton,
  Control,
  DropdownIndicator: null,
  Input,
  MultiValueContainer: Tag,
  MultiValueLabel: TagText,
  MultiValueRemove: TagDeleteButton,
};

const defaultTags = [];

const TagInput = ({
  disabled = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undef... Remove this comment to see the full error message
  id = null,
  invalid = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undef... Remove this comment to see the full error message
  name = null,
  isTagTextClipped = true,
  shouldCreateTagOnPaste = false,
  onBlur = Function.prototype,
  onChange,
  onCreateOption = defaultCreateOptionHandler,
  onFocus = Function.prototype,
  placeholder = '',
  tags = defaultTags,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState([]);
  const [isValuePasted, setIsValuePasted] = useState(false);
  const isMobile = bowser.mobile;
  const isTablet = bowser.tablet;
  const isTouchDevice = isMobile || isTablet;

  useEffect(() => {
    setValue(tags);
  }, [tags]);

  const handleCreateTag = (val = inputValue) => {
    const newTags = [...value, onCreateOption(val)];
    setValue(newTags);
    onChange(newTags);
    setInputValue('');
  };

  const handleInputChange = (inputVal, { action, prevInputValue }) => {
    if (isValuePasted && action === 'input-change') {
      handleCreateTag(inputVal);
      setIsValuePasted(false);

      return;
    }

    if (action === 'input-change') {
      setInputValue(inputVal);
    }

    if (action === 'input-blur' && prevInputValue) {
      handleCreateTag();
    }
  };

  const handleClear = () => {
    setValue([]);
    onChange([]);
    setInputValue('');
  };

  const handleChange = (newValue, { action }) => {
    if (action === 'clear') {
      handleClear();
      return;
    }

    setValue(newValue);
    onChange(newValue);
  };

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      handleCreateTag();
    }
  };

  const handlePaste = () => {
    if (shouldCreateTagOnPaste) {
      setIsValuePasted(true);
    }
  };

  const classes = classNames('ws-ui-tag-input', {
    'ws-ui-tag-input--invalid': invalid,
    'ws-ui-tag-input--is-disabled': disabled,
    'ws-ui-tag-input--is-mobile': isMobile,
  });

  return (
    <CreatableSelect
      className={classes}
      classNamePrefix="ws-ui-tag-input"
      // @ts-ignore TS(2322): Type '{ ClearIndicator: (props: Props) => React.JS... Remove this comment to see the full error message
      components={components}
      inputId={id}
      inputValue={inputValue}
      invalid={invalid}
      isClearable
      isDisabled={disabled}
      isTagTextClipped={isTagTextClipped}
      isMulti
      isTouchDevice={isTouchDevice}
      menuIsOpen={false}
      name={name}
      onBlur={onBlur}
      onChange={handleChange}
      onFocus={onFocus}
      onInputChange={handleInputChange}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      placeholder={placeholder}
      value={value}
    />
  );
};

export default TagInput;
